import { useExodus, useSelectors } from '@exodus/headless-react';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import useFromAsset from './use-from-asset.js';
import useToWalletAccount from './use-to-wallet-account.js';
const EMPTY_ARRAY = [];
const useExchangeToAssets = () => {
    const exodus = useExodus();
    const selectors = useSelectors();
    const [fromAsset] = useFromAsset();
    const [availableToAssets, setAvailableToAssets] = useState(new Set());
    const [loading, setLoading] = useState(false);
    const [toWalletAccount] = useToWalletAccount();
    const allAssetsByTicker = useSelector(selectors.assets.allByTicker);
    const allAssets = useSelector(selectors.assets.all);
    const assetsInWalletAccount = useSelector(selectors.assetSources.availableAssetNamesByWalletAccount)[toWalletAccount.toString()];
    useEffect(() => {
        if (fromAsset) {
            setLoading(true);
            void exodus.exchange
                .getSupportedToAssetIds(fromAsset.ticker)
                .then(setAvailableToAssets)
                .finally(() => setLoading(false));
        }
    }, [exodus.exchange, fromAsset]);
    const value = useMemo(() => {
        if (!fromAsset) {
            return EMPTY_ARRAY;
        }
        const assetTickersInWalletAccount = assetsInWalletAccount
            ? new Set([...assetsInWalletAccount]
                .map((assetName) => allAssets[assetName]?.ticker)
                .filter(Boolean))
            : new Set();
        return [...availableToAssets]
            .filter((ticker) => assetTickersInWalletAccount.has(ticker))
            .map((to) => allAssetsByTicker[to]);
    }, [fromAsset, assetsInWalletAccount, availableToAssets, allAssetsByTicker, allAssets]);
    return { value, loading };
};
export default useExchangeToAssets;
